import { z } from 'zod';

const playerSchema = z.object({
  _id: z.string(),
  name: z.string().optional(),
  extra: z.any().optional(),
}).passthrough();

export const formDataELBBSchema = z.object({
  TITULO: z.string().min(1, 'Nome da iniciativa é obrigatório').max(250, 'Máximo de 250 caracteres'),
  CATEGORIA: z.string().min(1, 'Categoria é obrigatória'),
  INDICADOR_NOME: z.string().optional(), // Campo oculto temporariamente - pode ser reativado
  inicioEntrega: z.string().min(1, 'Data de início é obrigatória'),
  conclusaoEntrega: z.string().min(1, 'Data de conclusão é obrigatória'),
  GESTOR_ATUAL_NOME: z.string().optional(),
  participantes: z.array(playerSchema).min(2, 'Adicione pelo menos 2 participantes (incluindo você)').max(5, 'Máximo de 5 participantes'),
  DESCRICAO: z.string().min(1, 'Descrição é obrigatória').max(500, 'Máximo de 500 caracteres'),
  RESULTADO: z.string().min(1, 'Campo obrigatório').max(2000, 'Máximo de 2000 caracteres'),
}).refine((data) => {
  if (data.inicioEntrega) {
    const inicio = new Date(data.inicioEntrega);
    return inicio.getFullYear() === 2025;
  }
  return true;
}, {
  message: 'A data de início deve ser do ano de 2025',
  path: ['inicioEntrega'],
}).refine((data) => {
  if (data.conclusaoEntrega) {
    const conclusao = new Date(data.conclusaoEntrega);
    return conclusao.getFullYear() === 2025;
  }
  return true;
}, {
  message: 'A data de conclusão deve ser do ano de 2025',
  path: ['conclusaoEntrega'],
}).refine((data) => {
  if (data.inicioEntrega && data.conclusaoEntrega) {
    const inicio = new Date(data.inicioEntrega);
    const conclusao = new Date(data.conclusaoEntrega);
    return inicio < conclusao;
  }
  return true;
}, {
  message: 'A data de início deve ser anterior à data de conclusão',
  path: ['conclusaoEntrega'],
});

export type FormDataELBBType = z.infer<typeof formDataELBBSchema>;
